import { useState } from "react";
import { createProfile } from "../lib/auth";

interface Props {
  userId: string;
  defaultDisplayName: string;
  avatarUrl: string | null;
  onDone: () => void;
}

export default function ProfileSetupScreen({
  userId,
  defaultDisplayName,
  avatarUrl,
  onDone,
}: Props) {
  const [displayName, setDisplayName] = useState(defaultDisplayName);
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit() {
    const name = displayName.trim();
    const phoneNumber = phone.trim();
    if (!name) {
      alert("Please enter your name.");
      return;
    }
    if (!phoneNumber) {
      alert("Please enter your phone number — WhatsApp reminders need it.");
      return;
    }
    setSubmitting(true);
    try {
      await createProfile(userId, name, phoneNumber, avatarUrl);
      onDone();
    } catch (err) {
      console.error(err);
      alert(err instanceof Error ? err.message : "Could not save profile");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="app-shell profile-setup">
      <h1 className="profile-setup__title">Welcome to Sprig</h1>
      <p className="profile-setup__sub">
        A couple of details before we plant anything.
      </p>

      {avatarUrl && (
        <img
          src={avatarUrl}
          alt="Your avatar"
          className="profile-setup__avatar"
        />
      )}

      <label className="section-label">DISPLAY NAME</label>
      <input
        className="text-input"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
        placeholder="e.g. Ada"
      />

      <label className="section-label" style={{ marginTop: 14 }}>
        PHONE NUMBER
      </label>
      <input
        className="text-input"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder="+1 555 123 4567"
        type="tel"
      />
      <p className="profile-setup__hint">
        Needed for WhatsApp watering reminders.
      </p>

      <button
        type="button"
        className="primary-btn"
        onClick={handleSubmit}
        disabled={submitting}
        style={{ marginTop: 24 }}
      >
        {submitting ? "Saving…" : "Continue"}
      </button>

      <style>{`
        .profile-setup { padding-top: 32px; }
        .profile-setup__title {
          font-family: Georgia, serif;
          font-size: 24px;
          font-weight: 700;
          color: #1f5a39;
          margin: 0 0 4px 0;
        }
        .profile-setup__sub {
          font-size: 13px;
          color: #6b7a6e;
          margin: 0 0 20px 0;
        }
        .profile-setup__avatar {
          width: 72px;
          height: 72px;
          border-radius: 36px;
          margin: 0 auto 16px auto;
        }
        .profile-setup__hint {
          font-size: 11px;
          color: #6b7a6e;
          margin: 6px 0 0 4px;
        }
      `}</style>
    </div>
  );
}
